import React from 'react';
import { Field } from 'formik';

const isArray = function (arg) {
  return Object.prototype.toString.call(arg) === '[object Array]';
};

const parseName = (name) => (isArray(name) ? name.join('.') : name);

const withFormikField =
  (Component) =>
  // eslint-disable-next-line
  ({ name, ...componentProps }) =>
    (
      <Field
        name={parseName(name)}
        render={(fieldProps) => (
          <Component
            {...componentProps}
            {...{
              ...fieldProps,
            }}
          />
        )}
      />
    );

export default withFormikField;
